import * as Yup from 'yup';

export type BankTransactionFormType = {
  transactionAt: Date | null;
  tempTransactionAt: Date | null;
  needApproval: boolean;
  bankAccountId: string | null;
  transactionCategoryId: string | null;
  type: string | null;
  amount: number;
  description: string;
  number?: string;
  refId?: string;
};

export const bankTransactionSchema = () =>
  Yup.object()
    .shape({
      transactionAt: Yup.date().nullable().required(),
      needApproval: Yup.boolean(),
      transactionCategoryId: Yup.string().nullable().required(),
      bankAccountId: Yup.string().nullable().required(),
      type: Yup.string().nullable().required(),
      amount: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0)
        .required(),
      description: Yup.string().nullable(),
      refId: Yup.string(),
    })
    .required();
